/* eslint-disable @typescript-eslint/no-unused-vars */
import { postAuth, getAuth } from "@/core/config/ApiService";

class Downline {
  async downlinesLists(data: any): Promise<any> {
    const resp = await postAuth("api/crm/downlines", data);
    return resp.data;
  }

  async addDownline(data: any): Promise<any> {
    const resp = await postAuth("api/crm/register-downline", data);
    return resp.data;
  }

  async changePassword(data: any): Promise<any> {
    const resp = await postAuth("api/crm/downline/password", data);
    return resp.data;
  }

  async loginHistory(data: any): Promise<any> {
    const resp = await postAuth("api/crm/downline/login-history", data);
    return resp.data;
  }

  async updateNickname(data: any): Promise<any> {
    const resp = await postAuth("api/crm/downline/nickname", data);
    return resp.data;
  }

  async bankList(data: any): Promise<any> {
    const resp = await postAuth("api/crm/downline/bank-accounts", data);
    return resp.data;
  }

  async uplineTree(username: any): Promise<any> {
    const resp = await getAuth(`api/crm/upline-tree?username=${username}`);
    return resp.data;
  }
}
export default new Downline();
